// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 279) return "../css/7.1.33960-account-summary.min.css";
	if (chunkId === 60) return "../css/7.1.33960-invite-user.min.css";
	if (chunkId === 167) return "../css/7.1.33960-account-comments.min.css";
	// return url for filenames based on template
	return undefined;
};